export const ExplorePaths = [
  'trending',
  'popular',
  'latest'
]



// WEBPACK FOOTER //
// ./assets/js/config/ExplorePaths.js